import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableHead, TableRow} from "@material-ui/core";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import annualReportSteps from "../../constants/annualReportSteps";
import Tr from "translations/Translations";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportExceptionEditForm from "./AnnualReportExceptionEditForm";
import AnnualReportExceptionTablePart from "./AnnualReportExceptionTablePart";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";

const reportStep = annualReportSteps.exception;

function AnnualReportExceptionForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict, formTr} = useContext(FormTranslationContext);
    const [types] = useState(getDict("SL.MMiA.063"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});

    if (!initValues) return <Loading/>
    return (<>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    <AnnualReportTableCell borderLeft>
                        <div>{Tr("column_lp")}</div>
                    </AnnualReportTableCell>
                    <AnnualReportTableHeadCell label="mmia.exception.type" colSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.exception.complete"/>
                    <AnnualReportTableHeadCell label="mmia.exception.contractValue"/>
                    <AnnualReportTableCell borderRight borderLeft/>
                </TableRow>

                {
                    types.map((type, index) =>
                        <AnnualReportExceptionTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            index={index}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                            reportStep={reportStep}
                        />
                    )
                }
            </TableHead>
        </Table>

        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={reportStep}
                FormComponent={AnnualReportExceptionEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.map((item, index) => ({
                    label: index + " - " + item.label,
                    value: item.value
                })).filter((item) => item.value !== movePopup.currentType)}
                onClose={() => setMovePopup(null)}
                inputLabel={formTr("mmia.exception.type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }

    </>)


}

AnnualReportExceptionForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportExceptionForm;